import React, { useState } from "react";
import { Card, Table, Form, Dropdown } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { BsCircleFill } from "react-icons/bs";
// import EditDepartmentModal from "./EditDepartmentModal";
// import DeleteModal from "./DeleteModal";
import DepartmentHeader from "../../components/hrm/employees/DepartmentHeader";
import EditDepartmentModal from "../../components/modals/hrm/employee/departments/EditDepartmentModal";
import DeleteDepartModal from "../../components/modals/hrm/employee/departments/DeleteDepartModal";

const initialData = [
  { id: 1, name: "Finance", emp: 20, status: "Active" },
  { id: 2, name: "Application Development", emp: 30, status: "Active" },
  { id: 3, name: "IT Management", emp: 15, status: "Active" },
  { id: 4, name: "Web Development", emp: 20, status: "Active" },
  { id: 5, name: "Sales", emp: 20, status: "Active" },
  { id: 6, name: "UI / UX", emp: 30, status: "Active" },
  { id: 7, name: "Account Management", emp: 15, status: "Active" },
  { id: 8, name: "Marketing", emp: 10, status: "Inactive" },
  { id: 9, name: "Administration", emp: 5, status: "Active" },
  { id: 10, name: "Business Development", emp: 7, status: "Active" },
];

const DepartmentPage = () => {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [statusFilter, setStatusFilter] = useState("");
  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);

  const filtered = data
    .filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
    .filter((item) => (statusFilter ? item.status === statusFilter : true))
    .slice(0, rows);

  return (
    <>
      <div style={{ padding: "15px", background: "#f8f9fa" }}>
        <DepartmentHeader />
        <Card style={{ border: "1px solid #e5e7eb" }}>
          {/* HEADER */}
          <div
            className="pt-3 ps-3"
            style={{
              padding: "4px",
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <h5>Department List</h5>

            <div style={{ display: "flex", gap: "1px" }}>
              {/* STATUS FILTER */}
              <Dropdown>
                <Dropdown.Toggle
                  className="text-dark rouned rouned-1"
                  style={{ background: "#fff", border: "1px solid #ddd" }}
                >
                  Status
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setStatusFilter("")}>
                    All
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setStatusFilter("Active")}>
                    Active
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setStatusFilter("Inactive")}>
                    Inactive
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* SORT (UI ONLY) */}
              <Dropdown>
                <Dropdown.Toggle
                  className="text-dark rouned rouned-1"
                  style={{ background: "#fff", border: "1px solid #ddd" }}
                >
                  Sort By : Last 7 Days
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Ascending</Dropdown.Item>
                  <Dropdown.Item>Descending</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <hr />
          {/* FILTER ROW */}
          <div
            style={{
              padding: "10px 16px",
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", gap: "10px" }}>
              Row Per Page
              <Form.Select
                style={{ width: "70px" }}
                onChange={(e) => setRows(Number(e.target.value))}
              >
                <option>5</option>
                <option>10</option>
                <option>20</option>
              </Form.Select>
              Entries
            </div>

            <Form.Control
              placeholder="Search"
              style={{ width: "200px" }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* TABLE */}
          <div style={{ overflowX: "auto" }}>
            <Table hover>
              <thead style={{ background: "#f9fafb" }}>
                <tr>
                  <th>
                    <Form.Check />
                  </th>
                  <th>Department</th>
                  <th>No of Employees</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Form.Check />
                    </td>

                    <td style={{ fontWeight: 500 }}>{item.name}</td>

                    <td>{item.emp}</td>

                    <td>
                      <span
                        style={{
                          background:
                            item.status === "Active" ? "#16a34a" : "#dc2626",
                          color: "#fff",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <BsCircleFill size={6} />
                        {item.status}
                      </span>
                    </td>

                    <td>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <FiEdit2
                          onClick={() => setEditItem(item)}
                          style={{ cursor: "pointer" }}
                        />
                        <FiTrash2
                          onClick={() => setDeleteItem(item)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>

        {/* EDIT MODAL */}
        {editItem && (
          <EditDepartmentModal
            show={true}
            data={editItem}
            handleClose={() => setEditItem(null)}
            handleSave={(updated) => {
              setData((prev) =>
                prev.map((i) => (i.id === updated.id ? updated : i)),
              );
              setEditItem(null);
            }}
          />
        )}

        {/* DELETE MODAL */}
        {deleteItem && (
          <DeleteDepartModal
            show={true}
            handleClose={() => setDeleteItem(null)}
            handleDelete={() => {
              setData((prev) => prev.filter((i) => i.id !== deleteItem.id));
              setDeleteItem(null);
            }}
          />
        )}
      </div>
    </>
  );
};

export default DepartmentPage;
